"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getGraphiteRelatedLinks = void 0;

require("core-js/modules/es.array.concat.js");

var _ = require("../..");

var _config = _interopRequireDefault(require("../config"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Get related links for a URL from Graphite's internal linking API.
 */
var getGraphiteRelatedLinks = function getGraphiteRelatedLinks(type, url) {
  var _config$api = _config.default.api,
      basePath = _config$api.basePath,
      routes = _config$api.routes;
  var graphiteRelatedLinks = routes.graphiteRelatedLinks;
  var requestUrl = "".concat(basePath).concat(graphiteRelatedLinks, "/").concat(type, "?url=").concat(url);
  return _.ApiService.get(requestUrl);
};

exports.getGraphiteRelatedLinks = getGraphiteRelatedLinks;